export const selectStateSetterForKey = (state) => state.setStateForKey
export const selectReset = (state) => state.reset
export const selectFullForm = (state) => state.form
export const selectStateSetter = (state) => state.setState
